/**
 * returns a 13-digit string to be used as a unique key for lists
 */
export const uiId = () => String(Math.random()).slice(2,15);

/**
 * function for Array.map will add to each element a property uiId
 * @param e - array of objects
 */
export const addUiIds = e => {
    e.uiId = uiId();
    return e;
};